import { computed, inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { AccountingPeriodService, AccountingPeriodSummary } from '../../../../../../../../api';
import { QueryKey } from '../../../../../../../constants/query-key';

@Injectable()
export class AccountingPeriodQueryService {
  private readonly accountingPeriodService = inject(AccountingPeriodService);

  periodsQuery = injectQuery(() => ({
    queryKey: [QueryKey.ACCOUNTING_PERIODS],
    queryFn: () => lastValueFrom(this.accountingPeriodService.getAccountingPeriods()),
  }));

  periods = computed<AccountingPeriodSummary[]>(() => this.periodsQuery.data()?.accountingPeriods ?? []);
  isLoading = computed(() => this.periodsQuery.isLoading());
}
